export const APP_NAMES = {
  portal: 'portal',
  vision: 'vision',
  modules: 'modules',
  gateway: 'gateways',
  insights: 'insights',
  academy: 'academy',
  docs: 'docs',
  conference: 'conference',
} as const

export const ENVIRONMENT_PREFIX = {
  dev: 'dev',
  test: 'tst',
  production: '',
} as const
